export default "__VITE_ASSET__c07f3aa8__"